module.exports = __webpack_public_path__ + "ClientApp/content/EuthanasiaSlider/Dr-Dani-Appt-4.jpg";